<template>
  <v-card flat color="transparent" class="mt-n4">
    <v-row>
      <v-col cols="12">
        <rs-question-matrix
          ref="matrixQuestion"
          :isValid.sync="valid"
          multiple
          :question="question"
          :responseAnswer="responseAnswer"
          @input="questionAnswer = $event"
          :themeColor="themeColor"
        ></rs-question-matrix>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import RsQuestionMatrix from "@/redsurvey/components/survey/objects/question/RsQuestionMatrix";
export default {
  components: {
    RsQuestionMatrix,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
    },
    isValid: {
      type: Boolean,
      default: false,
    },
    themeColor: {
      type: String,
      default: "primary"
    },
    responseAnswer: Object,
  },
  data() {
    return {
      questionAnswer: [],
      valid: this.isValid,
    };
  },
  methods: {
    checkValidation() {
      this.$refs.matrixQuestion.checkValidation();
    },
  },
  watch: {
    valid(v) {
      this.$emit("update:isValid", v);
    },
    questionAnswer(v) {
      this.$emit("input", v);
    },
  },
};
</script>

<style>
</style>